/**
 * Flagged/starred questions stored in localStorage.
 * Persists across sessions — not per-session.
 */

const STORAGE_KEY = 'flagged-questions';

export function getFlaggedQuestions(): string[] {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    return JSON.parse(raw) as string[];
  } catch {
    return [];
  }
}

export function isFlagged(questionId: string): boolean {
  return getFlaggedQuestions().includes(questionId);
}

export function toggleFlaggedQuestion(questionId: string): boolean {
  const current = getFlaggedQuestions();
  const idx = current.indexOf(questionId);
  if (idx >= 0) {
    current.splice(idx, 1);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(current));
    return false; // now unflagged
  } else {
    current.push(questionId);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(current));
    return true; // now flagged
  }
}

export function getFlaggedQuestionIds(allQuestionIds: string[]): string[] {
  const flagged = new Set(getFlaggedQuestions());
  return allQuestionIds.filter(id => flagged.has(id));
}
